import React from 'react'
import { RankmiTable } from '@rankmi/rankmi-table'
import type { ITemplate } from '@src/interfaces'
import type { TemplatesTableColumn, IColumnHeadersOverwrite } from './TemplatesTable.hooks'
import { useHeaders, useOrderedTemplates } from './TemplatesTable.hooks'

interface TemplatesTableProps {
  columnHeaders: TemplatesTableColumn[]
  overwriteColumns?: IColumnHeadersOverwrite[]
  templates?: ITemplate[]
}

export const TemplatesTable: React.FC<TemplatesTableProps> = ({
  columnHeaders,
  overwriteColumns,
  templates = []
}) => {
  const headers = useHeaders(columnHeaders, overwriteColumns)
  const [orderedTemplates, handleSortChange] = useOrderedTemplates(templates)

  return (
    <RankmiTable
      data={orderedTemplates}
      total={orderedTemplates.length}
      columnHeaders={headers}
      onSortChange={handleSortChange}
      locale={{
        header: { rowsCount: 'plantilla', rowsCount_plural: 'plantillas' }
      }}
    />
  )
}
